import { getMaxFileSizeError } from '../../utils/getMaxFileSizeError';
import { fileTooLargeCode } from './const';
export const getErrorMessage = (error, maxSize) => {
    if (maxSize) {
        if (error.code === fileTooLargeCode) {
            return getMaxFileSizeError(maxSize);
        }
    }
    return error.message;
};
